import { useEffect } from "react";

const DEFAULT_TITLE =
  "51网站在线观看免费播播足球－实时足球赛事直播与精彩回放";
const DEFAULT_DESC =
  "51网站在线观看免费播播足球提供丰富的足球赛事直播、精彩比赛视频和赛事解析，覆盖国内外多种足球赛事，让您随时在线观看最新足球直播及回放。";

export function usePageMeta(title?: string, description?: string) {
  useEffect(() => {
    document.title = title ?? DEFAULT_TITLE;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute("content", description ?? DEFAULT_DESC);
    }
  }, [title, description]);
}